module.exports = __webpack_public_path__ + "static/scale-model-of-virginia-park-in-ann-arbor-michigan-4093cd97920ac8f0c6f9161e369c96be.png";